import ButtonNew from 'client/components/entities/button-new'
import FieldNew from 'client/components/entities/field-new/field-new'
import { SearchResults } from 'client/components/entities/search-results'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryDescriptionInterface } from 'common/types/entities/BlogCategoryDescriptionInterface'
import { BlogCategoryTitleInterface } from 'common/types/entities/BlogCategoryTitleInterface'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import { ContactUsButtonInterface } from 'common/types/entities/contact-us-button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { LatestBlogPostsCarouselInterface } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import React from 'react'
import { Search } from 'src/editor/shared/entities/search'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import BlogBulletList from '../blog/entities/blog-bullet-list'
import Text from '../blog/entities/Text'
import Attachments, {
  AttachmentsInterface,
} from '../contact-us/entities/Attachments'
import ContactUs from '../contact-us/entities/ContactUs'
import ContactUsField from '../contact-us/entities/ContactUsField'
import ContactUsButton from '../contact-us/entities/contact-us-button'
import Recaptcha from '../contact-us/entities/Recaptcha'
import TextArea from '../contact-us/entities/TextArea'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import BlogCategoryDescription from './entities/BlogCategoryDescription'
import BlogCategoryTitle from './entities/BlogCategoryTitle'
import BlogLatestPosts from './entities/BlogLatestPosts'
import BlogPostListing from './entities/BlogPostListing'
import LatestBlogPostsCarousel from './entities/LatestBlogPostsCarousel'

export default function createEntityElementForBlogPage(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.BlogPostListing:
      return (
        <BlogPostListing
          entity={entity as BlogPostListingInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResults
          entity={entity as SearchResultsInterface}
          {...additionalProps}
        />
      )
    // case EntityTypeEnum.Search:
    //   return <Search entity={entity as SearchInterface} {...additionalProps} />
    case EntityTypeEnum.LatestBlogPosts:
      return (
        <BlogLatestPosts
          entity={entity as LatestBlogPostsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogCategoryTitle:
      return (
        <BlogCategoryTitle
          entity={entity as BlogCategoryTitleInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogCategoryDescription:
      return (
        <BlogCategoryDescription
          entity={entity as BlogCategoryDescriptionInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Text:
      return <Text entity={entity as TextInterface} {...additionalProps} />
    case EntityTypeEnum.BulletList:
      return (
        <BlogBulletList
          entity={entity as BulletListInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUs entity={entity as ContactUsInterface} {...additionalProps} />
      )
    case EntityTypeEnum.TextArea:
      return (
        <TextArea entity={entity as TextAreaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Field:
      return <FieldNew entity={entity as FieldInterface} {...additionalProps} />
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsField
          entity={entity as FieldInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew entity={entity as ButtonInterface} {...additionalProps} />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButton
          entity={entity as ContactUsButtonInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <Attachments
          entity={entity as AttachmentsInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LatestBlogPostsCarousel:
      return (
        <LatestBlogPostsCarousel
          entity={entity as LatestBlogPostsCarouselInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
